@if (_fna) {
  <h3 i18n>Total des besoins</h3>
  <ul>
    @if (_fna.debtAmount) {
      <li class="plus">
        <div class="needs__item">
          <p i18n>Dettes</p>
          <p>{{ _fna.debtAmount | emAmount: 'noDecimal' }} </p>
        </div>
      </li>
    }
    @if (_fna.mortgageAmount) {
      <li class="plus">
        <div class="needs__item">
          <p i18n>Hypothèque</p>
          <p>{{ _fna.mortgageAmount | emAmount: 'noDecimal' }} </p>
        </div>
      </li>
    }
    @if (_fna.funeralCost) {
      <li class="plus">
        <div class="needs__item">
          <p i18n>Frais funéraires</p>
          <p>{{ _fna.funeralCost | emAmount: 'noDecimal' }} </p>
        </div>
      </li>
    }
    @if (_fna.heritageAmount) {
      <li class="plus">
        <div class="needs__item">
          <p i18n>Héritage</p>
          <p>{{ _fna.heritageAmount | emAmount: 'noDecimal' }} </p>
        </div>
      </li>
    }
    @if (_fna.salaryReplacement) {
      <li class="plus">
        <div class="needs__item">
          <p i18n>Remplacement de revenu</p>
          <p>{{ _fna.salaryReplacement | emAmount }} </p>
        </div>
      </li>
    }
    @if (_fna.savingsAmount) {
      <li class="minus">
        <div class="needs__item">
          <p i18n>Économies (REER, CELI, etc.)</p>
          <p>({{ _fna.savingsAmount | emAmount: 'noDecimal' }}) </p>
        </div>
      </li>
    }
    @if (totalCurrentProtections) {
      <li class="minus">
        <div class="needs__item">
          <p i18n>Protections existantes</p>
          <p> ({{ totalCurrentProtections! | emAmount: 'noDecimal' }}) </p>
        </div>
      </li>
    }
  </ul>
  <p-divider></p-divider>
  @if (_fna.needs) {
    <h2 class="flex justify-content-end needs__total">{{ _fna.needs | emAmount }} </h2>
  }
}
@if (fnaSummary; as fnaSummary) {
  <h3 i18n>Calcul des besoins d’assurance vie</h3>
  <div>
    <div class="flex gap-3">
      @if (fnaSummary.temporaryNeeds) {
        <div class="w-full">
          <ng-container
            *ngTemplateOutlet="
              needsTable;
              context: {
                needs: fnaSummary.temporaryNeeds.needs,
                total: fnaSummary.temporaryNeeds.total,
                type: 'TEMPORARY',
              }
            "></ng-container>
        </div>
      }
      @if (fnaSummary.permanentNeeds) {
        <div class="w-full">
          <ng-container
            *ngTemplateOutlet="
              needsTable;
              context: {
                needs: fnaSummary.permanentNeeds.needs,
                total: fnaSummary.permanentNeeds.total,
                type: 'PERMANENT',
              }
            "></ng-container>
        </div>
      }
      @if (fnaSummary.totalNeeds) {
        <div class="layout__inner-card mt-0 w-full flex flex-column gap-3">
          <div>
            <div class="flex justify-content-between">
              <p class="m-0" i18n>Total</p>
              @if (fnaSummary.isComplete === false) {
                <p class="text-yellow-600" i18n
                  ><span class="pi pi-exclamation-triangle"></span> Analyse incomplète</p
                >
              }
            </div>
            <h3 class="m-0" i18n>Besoin d’assurance vie</h3>
          </div>
          <h4 class="text-4xl m-0 text-primary">{{ fnaSummary.totalNeeds | emAmount: 'noDecimal' }}</h4>
          <p class="m-0" i18n
            >Ce montant garantit à vos proches la stabilité financière pour maintenir leur mode de vie et
            gérer les obligations financières, même en votre absence.</p
          >
          @if (fnaSummary.disabilityNeeds || fnaSummary.cancerNeeds) {
            <p-divider></p-divider>
            <h3 class="m-0" i18n>Besoins supplémentaires</h3>
            @if (fnaSummary.disabilityNeeds) {
              <p class="m-0" i18n
                >Besoins en assurance invalidité (mensuel) :
                <span class="font-bold text-primary">{{
                  fnaSummary.disabilityNeeds | emAmount: 'noDecimal'
                }}</span>
              </p>
            }
            @if (fnaSummary.cancerNeeds) {
              <p class="m-0" i18n
                >Besoins en assurance cancer :
                <span class="font-bold text-primary">{{
                  fnaSummary.cancerNeeds | emAmount: 'noDecimal'
                }}</span>
              </p>
            }
          }
        </div>
      }
    </div>
  </div>
}

<ng-template #needsTable let-needs="needs" let-total="total" let-type="type">
  <p-table class="w-3" [value]="needs">
    <ng-template pTemplate="header">
      <tr>
        @if (type === 'PERMANENT') {
          <th i18n>Besoins permanents</th>
        }
        @if (type === 'TEMPORARY') {
          <th i18n>Besoins temporaires</th>
        }
        <th class="text-right">{{ total | emAmount: 'noDecimal' }}</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-need>
      <tr>
        <td>{{ need.title | emTranslate }}</td>
        <td class="text-right">{{ need.amount | emAmount: 'noDecimal' }}</td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>
